<template>
  <div id="materialAccessories">
    <div class="material" :class="{ minBox: bodyWidth <= 1680 }">
      <div class="material-tit">分销商门店资料</div>
      <div class="material-box">
        <div
          class="material-info"
          v-for="(item, index) in materialType"
          @click="toDetails(item.option)"
          :key="index"
        >
          <div class="material-cover">
            <img
              src="@/assets/image/bgProfessional QualificationCertificate.png"
              alt
            />
          </div>
          <div class="material-name">{{ item.option }}</div>
        </div>
        <div
          class="material-btn on"
          @click="showMore('员工离职资料')"
          v-if="key != '员工离职资料'"
        >
          更多资料
          <img src="@/assets/image/icon-open.png" alt />
        </div>
        <div
          class="material-btn off"
          @click="key = '-1'"
          v-if="key == '员工离职资料'"
        >
          <img src="@/assets/image/icon-off.png" alt />
          收起
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanySettings } from "@/http/api/system";
export default {
  data() {
    return {
      key: "",
      id: this.$route.params.id,
      bodyWidth: 1920,
      isShowWidth: false,
      materialType: [],
    };
  },
  mounted() {
    this.bodyWidth = document.body.clientWidth;
    // //console.log(this.bodyWidth,66666);
    if (this.bodyWidth > 1680) {
      this.isShowWidth = true;
    } else {
      this.isShowWidth = false;
    }
    this.getSettingsInfo();
  },
  methods: {
    showMore(val) {
      this.key = val;
    },
    toDetails(val) {
      this.$router.push(
        `/channel/franchisee/material-details/${this.id}?type=${val}`
      );
    },
    // 获取基础字段
    getSettingsInfo() {
      getCompanySettings().then((res) => {
        //console.log("获取基础字段:", res);
        res.result.forEach((item) => {
          //console.log(item.name,222);
          if (item.name == "Deer.Company.Collection.MaterialType") {
            this.materialType = item.value;
          }
        });
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#materialAccessories {
  min-height: calc(100vh - 220px);

  .material {
    position: relative;
    margin-bottom: 26px;
    padding: 25px 20px;
    min-height: calc(100vh - 215px);
    border-radius: $--border-radius-base;
    background-color: #fff;
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

    .material-tit {
      margin-bottom: 24px;
      font-size: 14px;
      font-weight: bold;
      color: #000;
    }

    .material-box {
      @include flex(row, center);
      flex-wrap: wrap;
    //   .material-info {
    //   width: 225px !important;
    //   height: 165px !important;
    //   .material-cover,
    //   .material-text {
    //     width: 205px !important;
    //     height: 122px !important;
    //   }
    // }
      .material-info {
        margin-right: 30px;
        margin-bottom: 24px;
        border: 1px solid #ddd;
        // width: 188px;
        // height: 144px;
        width: 225px !important;
        height: 165px !important;
        cursor: pointer;
        .material-cover {
          margin: 9px;
          border: 1px dashed #ddd;
          // width: 170px;
          // height: 100px;
          width: 205px !important;
        height: 122px !important;
          @include flex(column, center);
          justify-content: center;
          img {
            height: 30px;
          }
        }
        .material-text {
          margin: 9px;
          border: 1px dashed #ddd;
          // width: 170px;
          // height: 100px;
          width: 205px !important;
        height: 122px !important;
          @include flex(column, center);
          justify-content: center;
        }
        .material-name {
          margin: 0 9px 9px;
          color: #444;
        }
      }
    }
    .material-btn {
      @include flex(row, center);
      position: absolute;
      right: 20px;
      top: 68px;
      justify-content: center;
      margin-bottom: 24px;
      padding: 0 8px;
      border: 1px solid #ddd;
      writing-mode: tb-rl;
      height: 144px;
      line-height: 12px;
      font-size: 12px;
      cursor: pointer;
      letter-spacing: 7px;
      color: #444444;
      img {
        margin: 7px 0;
        width: 12px;
      }
    }
  }
  .material:last-child {
    margin-bottom: 0;
  }
  .minBox {
    .material-info {
      width: 225px !important;
      height: 165px !important;
      .material-cover,
      .material-text {
        width: 205px !important;
        height: 122px !important;
      }
    }
    .material-btn {
      height: 165px;
    }
  }
}
</style>
